import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=7146ddde&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=7146ddde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7146ddde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7146ddde')) {
      api.createRecord('7146ddde', component.options)
    } else {
      api.reload('7146ddde', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=7146ddde&scoped=true&", function () {
      api.rerender('7146ddde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zgYUX5HTshti/JS/comp/SearchFilterTokens.vue"
export default component.exports